import { render, staticRenderFns } from "./uploadEvidente.vue?vue&type=template&id=3c16a887&"
import script from "./uploadEvidente.vue?vue&type=script&lang=js&"
export * from "./uploadEvidente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports